import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { DatePicker } from 'primeng/datepicker';
import { TranslateModule } from '@ngx-translate/core';
import { DynamicDialogModule } from 'primeng/dynamicdialog';
import {
  DynamicDialogRef,
  DynamicDialogConfig,
  DialogService,
} from 'primeng/dynamicdialog';
import { ApiService, AuthService } from '../../_services';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SpinnerService } from '../spinner/spinner.service';
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';
import {
  DuplicateSlotRequestBody,
  DuplicateSlotsRequestBody,
  RestaurantSlot,
} from '../../_models/RestaurantSlot';
import { DateTime } from 'luxon';
import { TranslateService } from '@ngx-translate/core';
import { checkIfDateDifferenceIsValid } from '../../_utility/validators';

@Component({
  selector: 'app-duplicate-slots-dialog',
  templateUrl: './duplicate-slots-dialog.component.html',
  styleUrls: ['./duplicate-slots-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [DatePicker, ReactiveFormsModule, TranslateModule, DynamicDialogModule],
})
export class DuplicateSlotsDialogComponent implements OnInit {
  form: FormGroup;

  duplicateType?: 'multiple' | 'single';
  id_restaurant?: string;
  slot?: RestaurantSlot;
  date?: Date;
  today: Date = new Date();

  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    private fb: FormBuilder,
    private spinner: SpinnerService,
    private apiService: ApiService,
    public dialog: DialogService,
    private translate: TranslateService
  ) {
    if (config.data) {
      this.duplicateType = config.data.duplicateType;
      this.id_restaurant = config.data.id_restaurant;
      if (this.duplicateType === 'single') {
        this.slot = config.data.slot;
        this.form = this.fb.group({
          selectedDate: ['', [Validators.required]],
        });
      } else {
        this.date = config.data.date;
        this.form = this.fb.group({
          dateRange: [
            '',
            [Validators.required, checkIfDateDifferenceIsValid()],
          ],
        });
      }
    } else {
      this.form = this.fb.group({
        selectedDate: ['', [Validators.required]],
      });
    }
  }

  ngOnInit() {}
  Submit() {
    const ref = this.dialog.open(ConfirmDialogComponent, {
      styleClass: 'resizableDialog',
      header: this.translate.instant('confirm_dialog.duplicate_slot_title'),
      width: '50vw',
      modal: true,
      closable: true,
      data: {},
    });

    ref?.onClose.subscribe((o: any) => {
      if (o) {
        if (this.duplicateType === 'single') {
          this.spinner.show();
          const payload: DuplicateSlotRequestBody = {
            selected_date: DateTime.fromJSDate(
              this.form.value.selectedDate
            ).toSQLDate()!,
          };
          this.apiService
            .DuplicateSlot(
              this.id_restaurant!,
              this.slot!.id_restaurant_slot.toString(),
              payload
            )
            .subscribe({
              next: (data) => {
                this.spinner.hide();
                this.ref.close(data);
              },
              error: (error) => {
                console.error(error);
                this.spinner.hide();
              },
            });
        } else if (this.duplicateType === 'multiple') {
          this.spinner.show();

          const payload: DuplicateSlotsRequestBody = {
            selected_date: DateTime.fromJSDate(this.date!).toSQLDate()!,
            start_date: DateTime.fromJSDate(
              this.form.value.dateRange[0]
            ).toSQLDate()!,
            end_date:
              DateTime.fromJSDate(this.form.value.dateRange[1]).toSQLDate()! ||
              DateTime.fromJSDate(this.form.value.dateRange[0]).toSQLDate()!,
          };
          this.apiService
            .DuplicateSlots(this.id_restaurant!, payload)
            .subscribe({
              next: (data) => {
                this.spinner.hide();
                this.ref.close(data);
              },
              error: (error) => {
                console.error(error);
                this.spinner.hide();
              },
            });
        }
      }
    });
  }

  Close() {
    this.ref.close();
  }
}
